import React from 'react';
import classNames from 'classnames';
import { Shimmer } from '@fluentui/react';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { headerElement, buttonRowElement, largeBlockElement, footerElement } from '../helpers/shimmer-element';
import { getStyles } from '../styles/shimmer-card';


export function ShimmerCard() {
  const styles = useDefaultStyles(getStyles);

  return (
    <div className={classNames(styles.shimmerContainer, 'ba-device-loading-state')}>
      <Shimmer shimmerElements={headerElement} className={styles.shimmerElement} />
      <Shimmer shimmerElements={buttonRowElement} className={classNames(styles.shimmerElement, 'ba-device-loading-state-legend')} />
      <Shimmer shimmerElements={largeBlockElement} className={classNames(styles.shimmerElement, 'ba-device-loading-state-bar-chart')} />
      <Shimmer shimmerElements={largeBlockElement} className={classNames(styles.shimmerElement, 'ba-device-loading-state-bar-chart')} />
      <Shimmer shimmerElements={largeBlockElement} className={classNames(styles.shimmerElement, 'ba-device-loading-state-bar-chart')} />
      <Shimmer shimmerElements={footerElement} className={classNames(styles.footerElement, 'ba-device-loading-state-footer-button')} />
    </div>
  );
}
